import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Container, Row, Col } from 'react-bootstrap'
import { get, unionBy, isEqual } from 'lodash'
import NavigationLinks from 'components/molecules/NavigationLinks'
import * as customPageActions from 'store/modules/customPage/actions'

function SitemapWidget() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(customPageActions.getAccessMenus({ public: true, full: 1 }))
    dispatch(customPageActions.getFooterMenus({ public: true, full: 1 }))
    dispatch(customPageActions.getHeaderMenus({ public: true, full: 1 }))
  }, [])

  const { footerMenus, headerMenus } = useSelector(({ customPage }) => customPage, isEqual)
  const footerMainMenus = get(footerMenus, 'menuQuery.entity.links')
  const footerSubMenus = get(footerMenus, 'menuQuery.entity.links')
  const principalMenus = get(headerMenus, 'menuQuery.entity.links')
  const allLinks = unionBy(principalMenus, footerMainMenus, footerSubMenus, 'label')
  const menus = allLinks?.sort((itemA, itemB) => itemA.label.localeCompare(itemB.label))

  return (
    <Container className="sitemap-widget section-spacing px-2">
      <Row>
        <Col>{menus && <NavigationLinks items={menus} classNav="list" />}</Col>
      </Row>
    </Container>
  )
}

export default SitemapWidget
